export var projectCreationTourSteps = [
    // ── Step 1: 案件一覧ページ ──────────────────────────────────────────────
    // タブ右端の「＋ 案件を追加」リンクをハイライト。
    // クリックで /projects/new へ SPA 遷移し、Step 2 の要素が現れるまで待機する。
    {
        element: 'a.projects-tabs__add-button',
        popover: {
            title: '「＋ 案件を追加」をクリックして案件作成へ進みましょう',
            description: 'タブ右端のボタンから案件の作成フォームへ移動できます。<br>ボタンをクリックするか、「Next →」を押してください。',
            side: 'bottom'
        },
        nextTriggerSelector: 'a.projects-tabs__add-button',
        autoAdvanceTrigger: 'button-click',
        // Driver.js は初期描画前の高さでポップオーバーを配置するため、
        // onHighlighted（描画完了後）のタイミングで位置を補正する。
        afterHighlight: function () {
            var popover = document.querySelector('.driver-popover');
            var btn = document.querySelector('a.projects-tabs__add-button');
            if (!popover || !btn)
                return;
            var btnRect = btn.getBoundingClientRect();
            var stagePadding = 10;
            var arrowHeight = 8;
            // ボタン下端 + stagePadding + arrow の下にポップオーバーを配置
            popover.style.top = btnRect.bottom + stagePadding + arrowHeight + "px";
            popover.style.bottom = 'auto';
            // ボタンの右端に合わせて右寄せ
            var rightOffset = window.innerWidth - btnRect.right;
            popover.style.right = rightOffset + "px";
            popover.style.left = 'auto';
        }
    },
    // ── Step 2: 案件作成フォーム（基本情報タブ）── タイトル入力 ────────────
    // input 要素を直接ターゲットにする（ElInput → class="el-input__inner"）。
    // Enter または Tab を押すと次ステップへ自動進行する。
    {
        element: 'input[placeholder="工事案件のタイトルを入力"]',
        popover: {
            title: '案件のタイトルを入力してください',
            description: '工事案件の名称を入力します。後から変更できます。<br>入力後、<strong>Enter</strong> または <strong>Tab</strong> を押すと次のステップへ進みます。',
            side: 'right'
        },
        autoAdvanceTrigger: 'text-enter'
    },
    // ── Step 3: 顧客（発注元）選択フィールド ────────────────────────────────
    // クリックするとドロップダウンが開き、Step 4 へ自動進行する。
    {
        element: '.project-create-form .select-customer',
        popover: {
            title: '発注元（顧客）を選択してください',
            description: 'フィールドをクリックすると顧客の一覧が表示されます。<br>顧客名を入力して絞り込むこともできます。',
            side: 'right'
        },
        autoAdvanceTrigger: 'button-click'
    },
    // ── Step 4: 顧客選択ドロップダウン ──────────────────────────────────────
    // select-customer をクリックして開いたドロップダウンをハイライト。
    // 顧客を選択するとドロップダウンが閉じる → 手動で「Next →」を押して進む。
    {
        element: '.el-select-dropdown.el-popper.select-customers-dropdown',
        popover: {
            title: '顧客を選んでください',
            description: '一覧から発注元の顧客を選択します。<br>選択後、右下の「Next →」を押してください。',
            side: 'right'
        }
        // autoAdvanceTrigger 未指定 → 手動進行
    },
    // ── Step 6: 基本情報タブ「次へ」ボタン ──────────────────────────────────
    // 「次へ」を押すと案件概要タブへ遷移する。
    // nextTriggerSelector: ツアーの「Next →」押下時にフォームの「次へ」ボタンもクリックする。
    // autoAdvanceTrigger: フォームの「次へ」ボタンを直接クリックした場合もツアーを進める。
    {
        element: '.main-area--main .el-button--primary',
        popover: {
            title: '「次へ」を押して案件概要へ進みましょう',
            description: '「次へ」を押すと案件概要・工事概要・メモの順で詳細を入力できます。<br>今すぐ登録したい場合は「または、案件を今すぐ作成して詳細は後で入力する」をクリックしてください。',
            side: 'top'
        },
        nextTriggerSelector: '.main-area--main .el-button--primary',
        autoAdvanceTrigger: 'button-click'
    },
    // ── Step 7: 案件概要タブ ───────────────────────────────────────────────
    // 現場住所・連絡先などを入力するタブ。
    {
        element: '.project-overview-form .el-button--primary',
        popover: {
            title: '案件概要を入力してください',
            description: '現場の住所・担当者連絡先などを入力します。<br>入力後「次へ」を押すと工事概要へ進みます。',
            side: 'top'
        },
        nextTriggerSelector: '.project-overview-form .el-button--primary',
        autoAdvanceTrigger: 'button-click'
    },
    // ── Step 8: 工事概要タブ ───────────────────────────────────────────────
    // 工事種別・工期・現場画像などを入力するタブ。
    // 画像選択は任意のためスキップを促し、「次へ」ボタンを押させる。
    {
        element: '.project-construction-form .el-button--primary:not(.el-button--small)',
        popover: {
            title: '「次へ」を押してメモ・特記事項へ進みましょう',
            description: '画像の選択は今はスキップして、「次へ」を押してください。',
            side: 'top'
        },
        nextTriggerSelector: '.project-construction-form .el-button--primary:not(.el-button--small)',
        autoAdvanceTrigger: 'button-click'
    },
    // ── Step 9: メモ・特記事項タブ ─────────────────────────────────────────
    // 最終タブ。「完了」を押すと案件が登録される。
    {
        element: '.project-note-form .el-button--primary',
        popover: {
            title: 'メモ・特記事項を入力して完了',
            description: '現場に関するメモや特記事項を入力します。<br>入力が完了したら「完了」を押して案件を作成してください。',
            side: 'top'
        },
        nextTriggerSelector: '.project-note-form .el-button--primary',
        autoAdvanceTrigger: 'button-click'
    }
];
